import { GlobalState, RootState } from "../types";
import { GetterTree, ActionTree, MutationTree, Module } from "vuex";
import { LOGIN_TOGGLE } from "./getters.names";
import { TOGGLE_LOGIN } from "./mutations.names";
const namespaced: boolean = false;

export const state: GlobalState = {
  loginToggle: false
};

const getters: GetterTree<GlobalState, RootState> = {
  [LOGIN_TOGGLE](state: GlobalState): boolean {
    return state.loginToggle;
  }
};

const actions: ActionTree<GlobalState, RootState> = {};

const mutations: MutationTree<GlobalState> = {
  [TOGGLE_LOGIN](state: any, value = null) {
    state.loginToggle = value !== null ? value : !state.loginToggle;
  }
};

export const GlobalData: Module<GlobalState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
